module.exports = __webpack_public_path__ + "static/img/0544_8.416edb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0544_8.jpg
// module id = QAVX
// module chunks = 1